const styles = (theme) => ({
  searchControl: {
    marginLeft: theme.spacing(),
    maxWidth: 230,
  },
  form: {
    width: "100%",
  },
  inputFocused: {
    "& $notchedOutline": {
      borderColor: [theme.palette.secondary.main, "!important"],
    },
  },
  notchedOutline: {},
  inputAdornment: {
    position: "relative",
    width: 30 + theme.spacing(),
    height: 30,
  },
  adornedEnd: {
    paddingRight: [0, "!important"],
  },
  button: {
    position: "absolute",
  },
  mobileSearchToolbar: {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
})

export default styles
